import {
  ChakraProvider,
  HStack,
  Stack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Select,
  Button,
  VStack,
  Text,
  Input,
} from '@chakra-ui/react'
import { getHours, isWeekend, parse, addMinutes, isBefore, format } from 'date-fns'
const OrderEditModal = ({ order, onClose, onOrderUpdate, onOrderSave, onOrderDelete }: any) => {
  const getHours = () => {
    if (!order) {
      return []
    }

    const date = parse(order.date, 'y-MM-dd', new Date())
    const hours = []
    let increase = true

    let startCounter = parse('08:15', 'HH:mm', new Date())
    let finishCounter = parse('11:00', 'HH:mm', new Date())
    if (isWeekend(date)) {
      startCounter = parse('09:15', 'HH:mm', new Date())
      finishCounter = parse('11:30', 'HH:mm', new Date())
    }

    while (increase) {
      hours.push({
        key: format(startCounter, 'H:mm'),
        value: format(startCounter, 'H:mm'),
      })
      startCounter = addMinutes(startCounter, 15)
      if (isBefore(finishCounter, startCounter)) {
        increase = false
      }
    }

    return hours
  }

  const getWaiterHours = () => {
    if (!order) {
      return []
    }

    const hours = []
    let increase = true

    let startCounter = parse('08:00', 'HH:mm', new Date())
    const finishCounter = parse('23:59', 'HH:mm', new Date())

    while (increase) {
      hours.push({
        key: format(startCounter, 'H:mm'),
        value: format(startCounter, 'H:mm'),
      })
      startCounter = addMinutes(startCounter, 15)
      if (isBefore(finishCounter, startCounter)) {
        increase = false
      }
    }

    return hours
  }

  const getTables = () => {
    const tables = []
    for (let i = 1; i <= 40; i++) {
      tables.push({
        key: i.toString(),
        value: i,
      })
    }
    return tables
  }

  const getGuests = () => {
    const guests = []
    for (let i = 0; i <= 50; i++) {
      guests.push({
        key: i.toString(),
        value: i,
      })
    }
    return guests
  }

  const renderModalBody = () => {
    if (order.type === 'reservation') {
      return (
        <VStack alignItems='flex-start' spacing={4}>
          <HStack>
            <Text minWidth='70px'>Name:</Text>
            <Text fontWeight='bold'>{order.name}</Text>
          </HStack>
          <HStack>
            <Text minWidth='70px'>Room:</Text>
            <Text fontWeight='bold'>{order.room}</Text>
          </HStack>
          <HStack>
            <Text minWidth='70px'>Date:</Text>
            <Text fontWeight='bold'>{order.date}</Text>
          </HStack>
          <HStack>
            <Text minWidth='70px'>Time:</Text>
            <Select
              defaultValue={order.time}
              variant='filled'
              onChange={(e) => onOrderUpdate(order, 'time', e.target.value)}
            >
              {getHours().map((option) => (
                <option key={option.key} value={option.key}>
                  {option.value}
                </option>
              ))}
            </Select>
          </HStack>
          <HStack>
            <Text minWidth='70px'>Location:</Text>
            <Select
              defaultValue={order.location}
              variant='filled'
              onChange={(e) => onOrderUpdate(order, 'location', e.target.value)}
            >
              <option value='to the room'>In the room</option>
              <option value='at the lobby restaurant'>At the lobby restaurant</option>
              <option value='terace'>At the terace</option>
            </Select>
          </HStack>
        </VStack>
      )
    }

    return (
      <VStack alignItems='flex-start' spacing={4}>
        <HStack w='full'>
          <Text minWidth='70px'>Time:</Text>
          <Select
            defaultValue={order.time}
            variant='filled'
            onChange={(e) => onOrderUpdate(order, 'time', e.target.value)}
          >
            {getWaiterHours().map((option) => (
              <option key={option.key} value={option.key}>
                {option.value}
              </option>
            ))}
          </Select>
        </HStack>
        <HStack w='full'>
          <Text minWidth='70px'>Location:</Text>
          <Select
            defaultValue={order.location}
            variant='filled'
            onChange={(e) => onOrderUpdate(order, 'location', e.target.value)}
          >
            <option value='-'>-</option>
            <option value='to the room'>In the room</option>
            <option value='at the lobby restaurant'>At the lobby restaurant</option>
            <option value='terace'>At the terace</option>
          </Select>
        </HStack>
        <HStack w='full'>
          <Text minWidth='70px'>Table No:</Text>
          <Select
            defaultValue={order.orderTable}
            variant='filled'
            onChange={(e) => onOrderUpdate(order, 'orderTable', e.target.value)}
          >
            {getTables().map((option) => (
              <option key={option.key} value={option.key}>
                {option.value}
              </option>
            ))}
          </Select>
        </HStack>
        <HStack w='full'>
          <Text minWidth='70px'>Name:</Text>
          <Input
            value={order.orderName ?? ''}
            onChange={(e) => onOrderUpdate(order, 'orderName', e.target.value)}
          />
        </HStack>
        <HStack w='full'>
          <Text minWidth='70px'>Phone:</Text>
          <Input
            value={order.orderPhone ?? ''}
            onChange={(e) => onOrderUpdate(order, 'orderPhone', e.target.value)}
          />
        </HStack>
        <HStack w='full'>
          <Text minWidth='70px'>Guests:</Text>
          <Select
            defaultValue={order.orderGuests}
            variant='filled'
            onChange={(e) => onOrderUpdate(order, 'orderGuests', e.target.value)}
          >
            {getGuests().map((option) => (
              <option key={option.key} value={option.key}>
                {option.value}
              </option>
            ))}
          </Select>
        </HStack>
      </VStack>
    )
  }

  return (
    <Modal isOpen={order} onClose={onClose}>
      <ModalOverlay />
      {order && (
        <ModalContent>
          <ModalHeader>Edit order</ModalHeader>
          <ModalCloseButton />
          <ModalBody>{renderModalBody()}</ModalBody>

          <ModalFooter justifyContent={order.type === 'reservation' ? 'flex-end' : 'space-between'}>
            {order.type !== 'reservation' && (
              <Button colorScheme='red' mr={3} onClick={() => onOrderDelete(order)}>
                Delete
              </Button>
            )}

            <Button colorScheme='green' mr={3} onClick={() => onOrderSave(order)}>
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      )}
    </Modal>
  )
}

export default OrderEditModal
